import { render, staticRenderFns } from "./danni.vue?vue&type=template&id=1f93e341"
import script from "./danni.vue?vue&type=script&lang=js"
export * from "./danni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f93e341')) {
      api.createRecord('1f93e341', component.options)
    } else {
      api.reload('1f93e341', component.options)
    }
    module.hot.accept("./danni.vue?vue&type=template&id=1f93e341", function () {
      api.rerender('1f93e341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/danni.vue"
export default component.exports